import React from 'react';

const tipWrap = {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: 6,
  cursor: 'help'
};

const iconStyle = {
  display: 'inline-block',
  width: 16,
  height: 16,
  lineHeight: '16px',
  textAlign: 'center',
  borderRadius: '50%',
  border: '1px solid #999',
  fontSize: 12,
  userSelect: 'none'
};

const bubbleStyle = {
  position: 'absolute',
  left: '100%',
  top: '50%',
  transform: 'translate(8px, -50%)',
  maxWidth: 320,
  background: '#111',
  color: '#fff',
  padding: '8px 10px',
  borderRadius: 8,
  fontSize: 12,
  lineHeight: 1.35,
  boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
  zIndex: 50,
  whiteSpace: 'normal'
};

export default function InfoTooltip({ label = 'i', text, ariaLabel = 'More info' }) {
  const [open, setOpen] = React.useState(false);

  return (
    <span
      style={tipWrap}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      aria-label={ariaLabel}
    >
      <span style={iconStyle} aria-hidden="true">
        {label}
      </span>
      {open && text ? (
        <span role="tooltip" style={bubbleStyle}>
          {text}
        </span>
      ) : null}
    </span>
  );
}
